module.exports = __webpack_public_path__ + "static/img/people1.afff473.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/people1.jpg
// module id = d5zr
// module chunks = 1